import searchLineStyle from 'src/components/View/Header/searchLine.style';

const searchStyle = (theme) => ({
  root: {
    ...searchLineStyle(theme)?.innerField || {},
  },

  innerFieldDropDown: {
    ...searchLineStyle(theme)?.innerFieldDropDown || {},
  },
});

export default searchStyle;
